<div class="container p-4 my-5">
  <h1>Število registriranih uporabnikov ({{ userCount }})</h1>
  <div *ngIf="allUsers.length === 0" class="spinner">
    <p>No users found.</p>
  </div>
  <div *ngIf="allUsers.length > 0">
    <div class="user-list">
      <div class="user-item" *ngFor="let user of allUsers">
        <h3>{{ user.username }}</h3>
        <p><strong>Email:</strong> {{ user.email }}</p>
        <p><strong>Telefon:</strong> {{ user.phone }}</p>
        <p><strong>Naslov:</strong> {{ user.address }}</p>
        <p><strong>Registriral:</strong> {{ user.joined | date: 'dd-MM-yyyy HH:mm' }}</p>
        <button class="btn btn-danger" (click)="deleteUser(user.userID)">Izbriši uporabnika</button>
      </div>
    </div>
  </div>
</div>
